import React from 'react';
import './_FloatingActionButton.scss';
import PropTypes from 'prop-types';
import { HelpAnywhereUhmTriggerIcon, HelpAnywhereAvaAvatarIcon} from '@apothecary/community-icons';

const FloatingActionButton = ({
  flags:{
    experimentOne
  },
  isInProduct
}) => {
  const experimentClassName = experimentOne ? ' experiment-flag' : '';

  return (
    <>
      <div className="uh-fab-content">
        <div className={"uh-fab-icon" + experimentClassName}>{
          isInProduct ? <HelpAnywhereAvaAvatarIcon /> : <HelpAnywhereUhmTriggerIcon />
        }</div>
      </div>
    </>
  );
};

FloatingActionButton.defaultProps = {
  flags: {
    experimentOne: false
  },
  isInProduct: false
}

// Set proptype rules
FloatingActionButton.propTypes = {
  flags: PropTypes.object,
  isInProduct: PropTypes.bool
};

export default FloatingActionButton;
